module.exports = __webpack_public_path__ + "img/exclamation-icon.f0176ddf.svg";